import { memo } from 'react'
import type { ReactNode } from 'react'
import { Link } from 'react-router-dom'
import Navbar from './Navbar'
import logoImage from '../../assets/logo/logo.png'
import { showConsentSettings } from '../../utils/cookieConsentConfig'

interface LayoutProps {
  children: ReactNode
  currentHome?: "home_a" | "home_b"
  onHomeChange?: (home: "home_a" | "home_b") => void
  selectedChild?: string
  onChildChange?: (childId: string) => void
  childrenData?: any[]
  isLoading?: boolean
  currentView?: "care" | "events"
  onViewChange?: (view: "care" | "events") => void
  onAddEventClick?: () => void
}

const Layout = memo<LayoutProps>(({
  children,
  currentHome = "home_a",
  onHomeChange,
  selectedChild,
  onChildChange,
  childrenData,
  isLoading,
  currentView = "care",
  onViewChange,
  onAddEventClick
}) => {
  return (
    <div className="flex flex-col bg-gray-50">
      <Navbar
        currentHome={currentHome}
        onHomeChange={onHomeChange}
        selectedChild={selectedChild}
        onChildChange={onChildChange}
        children={childrenData}
        isLoading={isLoading}
        currentView={currentView}
        onViewChange={onViewChange}
        onAddEventClick={onAddEventClick}
      />
      <main className="flex-grow container mx-auto px-4 py-3">
        {children}
      </main>
      <footer className="bg-white shadow-inner py-4">
        <div className="container mx-auto px-4">
          <div className="flex flex-col items-center justify-center space-y-2">
            <div className="flex items-center justify-center space-x-4">
              <img src={logoImage} alt="2homes.app logo" className="h-8 w-auto" />
              <div className="text-sm text-gray-500">
                © 2025 2homes.app - Co-parenting calendar for parents and caregivers
              </div>
            </div>

            <div className="text-xs text-gray-400 flex flex-row items-center justify-center space-x-4">
              <Link to="/terms" className="hover:underline whitespace-nowrap">Terms</Link>
              <Link to="/privacy-policy" className="hover:underline whitespace-nowrap">Privacy</Link>
              <span
                role="button"
                tabIndex={0}
                onClick={() => showConsentSettings()}
                onKeyDown={(e) => e.key === 'Enter' && showConsentSettings()}
                className="hover:underline cursor-pointer whitespace-nowrap"
              >
                Cookies
              </span>
              <Link to="/contact" className="hover:underline whitespace-nowrap">Contact</Link>
            </div>
          </div>
        </div>
      </footer>
    </div>
  )
})

export default Layout